import i18n from 'modules/core/lib/i18n'

import { CardWithStatus } from './types'

export const statusText = (card: CardWithStatus): string => {
  if (card.approval?.status === 'rejected') {
    return i18n.t('expenses_v2.cards.status.rejected')
  } else if (card.approval?.status === 'running') {
    return i18n.t('expenses_v2.cards.status.requested')
  } else if (
    card.approval?.status === 'approved' &&
    (card.status === 'requested' || card.status === 'pending')
  ) {
    return i18n.t('expenses_v2.cards.status.approved')
  } else {
    switch (card.status) {
      case 'pending':
        return i18n.t('expenses_v2.cards.status.pending')
      case 'active':
        return i18n.t('expenses_v2.cards.status.active')
      case 'inactive':
        return i18n.t('expenses_v2.cards.status.inactive')
      case 'requested':
        return i18n.t('expenses_v2.cards.status.requested')
      case 'rejected':
        return i18n.t('expenses_v2.cards.status.rejected')
      case 'canceled':
        return i18n.t('expenses_v2.cards.status.canceled')
      default:
        return i18n.t('expenses_v2.cards.status.pending')
    }
  }
}
